export const state = {
    breadcrumbItems: []
};

export const mutations = {
  breadcrumbAdded(state, item){
    if(state.breadcrumbItems) {
      const parentLevel = item.level - 1;
      const parent = state.breadcrumbItems.find(existingItem => existingItem.level == parentLevel);
      if (parent) parent.active = false;

      state.breadcrumbItems
        .filter(existingItem => existingItem.level >= item.level)
        .forEach(existingItem => {
          const index = state.breadcrumbItems.indexOf(existingItem);
          if (index > -1) state.breadcrumbItems.splice(index, 1);
        });
    }
    state.breadcrumbItems.push(item)
  },
  parentPassive(state, parent) {
    parent.active = false
  },
  updateBreadcrumbLabel(state, { label, propertyId, areaId, itemId }) {
    let breadcrumb;
    if (propertyId) breadcrumb = state.breadcrumbItems.find(b => b.propertyId == propertyId);
    else if (areaId) breadcrumb = state.breadcrumbItems.find(b => b.areaId == areaId);
    else breadcrumb = state.breadcrumbItems.find(b => b.itemId == itemId);

    breadcrumb.text = label;
  }
}
